var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.print_type,{tag:"component",attrs:{"bill_receivable_group":_vm.bill_receivable_group,"company":_vm.company,"hasAddress":_vm.hasAddress,"hasPhones":_vm.hasPhones}})}
var staticRenderFns = []

export { render, staticRenderFns }